import { render, staticRenderFns } from "./ButtonResponse.vue?vue&type=template&id=a890d8ae&scoped=true"
import script from "./ButtonResponse.vue?vue&type=script&lang=js"
export * from "./ButtonResponse.vue?vue&type=script&lang=js"
import style0 from "./ButtonResponse.vue?vue&type=style&index=0&id=a890d8ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a890d8ae",
  null
  
)

export default component.exports